<mat-toolbar>
    <mat-icon (click)="main.menuExpanded = !main.menuExpanded">menu</mat-icon>
    <div class="logo"><img src="assets/geislinger-logo.svg" alt="logo"></div>
</mat-toolbar>
